var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeguroVidaAhorro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70.1 84",
    style: {
      enableBackground: "new 0 0 70.1 84"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#95D4E9;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:#FFFFFF;stroke:#95D4E9;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Seguro_Vida_con_ahorro",
    transform: "translate(-701.383 -925.705)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9700",
    transform: "translate(702.383 975.951)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19005",
    className: "st0",
    d: "M42.1,18c0,0,12.7-5.3,17.2-6c2.7-0.5,5.5,0.3,7.6,2.2c1.3,1.1,1.4,3,0.3,4.2 c-0.3,0.4-0.8,0.7-1.3,0.9L30.4,32.1c-2.6,0.9-5.5,0.8-8-0.4L1.7,22C0.7,21.5,0,20.5,0,19.3V3c0-1.7,1.4-3,3-3c0.1,0,0.2,0,0.3,0 c3.4,0.3,8.1,1.5,14.7,5.9h13.2C38.3,5.9,42.1,11.3,42.1,18H18.1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9701",
    transform: "translate(723.806 926.705)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19006",
    className: "st0",
    d: "M0,25.4c0,1.2,0.5,2.4,1.4,3.2c1.8,1.9,5.3,3.2,9.2,3.2s7.3-1.3,9.2-3.2 c0.9-0.8,1.4-2,1.4-3.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19007",
    className: "st0",
    d: "M21.2,31.8c0,1.2-0.5,2.4-1.4,3.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19008",
    className: "st0",
    d: "M1.4,35C0.5,34.2,0,33,0,31.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19009",
    className: "st0",
    d: "M0,12.7c0,1.2,0.5,2.4,1.4,3.2c1.8,1.9,5.3,3.2,9.2,3.2s7.3-1.3,9.2-3.2 c0.9-0.8,1.4-2,1.4-3.2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_1748",
    className: "st1",
    cx: 10.6,
    cy: 6.4,
    rx: 10.6,
    ry: 6.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19010",
    className: "st0",
    d: "M0,19.1c0,1.2,0.5,2.4,1.4,3.2c1.8,1.9,5.3,3.2,9.2,3.2s7.3-1.3,9.2-3.2 c0.9-0.8,1.4-2,1.4-3.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19011",
    className: "st0",
    d: "M0,38.2c0,3.5,4.8,6.4,10.6,6.4s10.6-2.8,10.6-6.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19012",
    className: "st0",
    d: "M1.4,35c1.8,1.9,5.3,3.2,9.2,3.2s7.3-1.3,9.2-3.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19013",
    className: "st0",
    d: "M21.2,38.2V6.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19014",
    className: "st0",
    d: "M0,38.2V6.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19015",
    className: "st0",
    d: "M25.5,38.2c0,1.2,0.5,2.4,1.4,3.2c1.8,1.9,5.3,3.2,9.2,3.2s7.3-1.3,9.2-3.2 c0.9-0.8,1.4-2,1.4-3.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19016",
    className: "st0",
    d: "M25.5,25.4c0,1.2,0.5,2.4,1.4,3.2c1.8,1.9,5.3,3.2,9.2,3.2s7.3-1.3,9.2-3.2 c0.9-0.8,1.4-2,1.4-3.2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_1749",
    className: "st1",
    cx: 36.1,
    cy: 19.1,
    rx: 10.6,
    ry: 6.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19017",
    className: "st0",
    d: "M25.5,31.8c0,1.2,0.5,2.4,1.4,3.2c1.8,1.9,5.3,3.2,9.2,3.2s7.3-1.3,9.2-3.2 c0.9-0.8,1.4-2,1.4-3.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19018",
    className: "st0",
    d: "M46.7,19.1v19.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19019",
    className: "st0",
    d: "M25.5,19.1v19.1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeguroVidaAhorro);
export default __webpack_public_path__ + "static/media/Seguro-Vida-Ahorro.771dfcf48891782a8407a718352580d8.svg";
export { ForwardRef as ReactComponent };